import { deviceAttrGetLatestFormatted, RaftDeviceManager } from "@robotical/raftjs";

/* LIGHT ATTRIBUTES */
const COG_LIGHT_DEVICE_TYPE = 'Cog Light Sensors';
const AMB0_KEY = 'amb0';
const IR0_KEY = 'ir0';
const IR1_KEY = 'ir1';
const IR2_KEY = 'ir2';
/* POWER ATTRIBUTES */
const COG_POWER_DEVICE_TYPE = "Cog Power Status";
const BATTV_KEY = 'battV';
const USB_KEY = 'onUSB';
/* I2CA ATTRIBUTES */
const COG_I2CA_DEVICE_TYPE_OLD1 = "LSM6DS";
const COG_I2CA_DEVICE_TYPE_OLD2 = "LSM6DS3TRC";
const COG_I2CA_DEVICE_TYPE_NEW1 = "MXC4005XC";
const COG_I2CA_DEVICE_TYPE_NEW2 = "MXC400xXC";
const COG_I2CA_DEVICE_TYPE_NEW3 = "MXC4005CX";
const AX_KEY = 'ax';
const AY_KEY = 'ay';
const AZ_KEY = 'az';
const GX_KEY = 'gx';
const GY_KEY = 'gy';
const GZ_KEY = 'gz';


const getDeviceAttributesHelper = (deviceManager: RaftDeviceManager, deviceTypes: string[]) => {
    for (const key in deviceManager._devicesState) {
        if (deviceTypes.includes(deviceManager._devicesState[key].deviceType)) {
            return deviceManager._devicesState[key];
        }
    }
    return undefined;
};

export default class PublishedDataGetter {

    static getPowerData(deviceManager: RaftDeviceManager): { battV: number, usb: "yes" | "no" } {
        try {
            const powerAttr = getDeviceAttributesHelper(deviceManager, [COG_POWER_DEVICE_TYPE]);
            if (!powerAttr) return { battV: 0, usb: "no" };
            const battV = deviceAttrGetLatestFormatted(powerAttr?.deviceAttributes[BATTV_KEY]);
            const usb = deviceAttrGetLatestFormatted(powerAttr?.deviceAttributes[USB_KEY]);
            return { battV: convertStringToNumber(battV), usb: usb as "yes" | "no" };
        } catch (e) {
            return { battV: 0, usb: "no" };
        }
    }

    static getAccelerometerData(deviceManager: RaftDeviceManager): { ax: number, ay: number, az: number } {
        try {
            const i2caAttr = getDeviceAttributesHelper(deviceManager, [COG_I2CA_DEVICE_TYPE_OLD1, COG_I2CA_DEVICE_TYPE_OLD2, COG_I2CA_DEVICE_TYPE_NEW1, COG_I2CA_DEVICE_TYPE_NEW2, COG_I2CA_DEVICE_TYPE_NEW3]);
            if (!i2caAttr) return { ax: 0, ay: 0, az: 0 };
            const i2ca = i2caAttr.deviceAttributes;
            const ax = deviceAttrGetLatestFormatted(i2ca[AX_KEY]);
            const ay = deviceAttrGetLatestFormatted(i2ca[AY_KEY]);
            const az = deviceAttrGetLatestFormatted(i2ca[AZ_KEY]);
            return { ax: convertStringToNumber(ax), ay: convertStringToNumber(ay), az: convertStringToNumber(az) };
        } catch (e) {
            return { ax: 0, ay: 0, az: 0 };
        }
    }

    static getGyroscopeData(deviceManager: RaftDeviceManager): { gx: number, gy: number, gz: number } {
        try {
            const i2caAttr = getDeviceAttributesHelper(deviceManager, [COG_I2CA_DEVICE_TYPE_OLD1, COG_I2CA_DEVICE_TYPE_OLD2, COG_I2CA_DEVICE_TYPE_NEW1, COG_I2CA_DEVICE_TYPE_NEW2, COG_I2CA_DEVICE_TYPE_NEW3]);
            if (!i2caAttr) return { gx: 0, gy: 0, gz: 0 };
            const i2ca = i2caAttr.deviceAttributes;
            const gx = deviceAttrGetLatestFormatted(i2ca[GX_KEY]);
            const gy = deviceAttrGetLatestFormatted(i2ca[GY_KEY]);
            const gz = deviceAttrGetLatestFormatted(i2ca[GZ_KEY]);
            return { gx: convertStringToNumber(gx), gy: convertStringToNumber(gy), gz: convertStringToNumber(gz) };
        } catch (e) {
            return { gx: 0, gy: 0, gz: 0 };
        }
    }

    static getLightData(deviceManager: RaftDeviceManager): { amb0: number, ir0: number, ir1: number, ir2: number } {
        try {
            const lightAttr = getDeviceAttributesHelper(deviceManager, [COG_LIGHT_DEVICE_TYPE]);
            if (!lightAttr) return { amb0: 0, ir0: 0, ir1: 0, ir2: 0 };
            const light = lightAttr.deviceAttributes;
            const amb0 = deviceAttrGetLatestFormatted(light[AMB0_KEY]);
            const ir0 = deviceAttrGetLatestFormatted(light[IR0_KEY]);
            const ir1 = deviceAttrGetLatestFormatted(light[IR1_KEY]);
            const ir2 = deviceAttrGetLatestFormatted(light[IR2_KEY]);
            return { amb0: convertStringToNumber(amb0), ir0: convertStringToNumber(ir0), ir1: convertStringToNumber(ir1), ir2: convertStringToNumber(ir2) };
        } catch (e) {
            return { amb0: 0, ir0: 0, ir1: 0, ir2: 0 };
        }   
    }
}



const convertStringToNumber = (str: string) => {
    return isNaN(+str) ? 0 : +str;
}